// **********************************************************
// 1.0 - pin Modal Close
// **********************************************************

attachEvent('.pin-modal__close, .pin-modal__overlay', 'click', (ev) => {
  ev.target.closest('.pin-modal').classList.remove('is-open-modal');
});

// **********************************************************
// 2.0 - Closing Modal on Esc
// **********************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.pin-modal').forEach((el) => {
      el.classList.remove('is-open-modal');
    });
  }
});
